import { app } from '../../../../../app';
import { Controller } from './edit-display-name.controller';

app.component('companyUserDirectoriesManageUserEditDisplayName', {
    bindings: {
        companyId: '<',
        companyUser: '<',
        displayNames: '<',
    },
    controller: Controller,
    templateUrl: require('./edit-display-name.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/edit-display-name/edit-display-name.component.js